import React from "react";
import { Card } from "@material-ui/core";
import MovieTix from "../assets/MovieTix.png";
import HelpingUp from "../assets/HelpingUp.png";
import NeedHelp from "../assets/NeedHelp.png";

function HowItWorks() {
  return (
    <div
      className="row"
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        fontFamily: "Raleway",
        backgroundColor: "white",
        justifyContent: "space-evenly",
        flexWrap: "wrap",
        paddingTop: "5%",
        paddingBottom: "15%"
      }}
    >
      {/* <div className="col" style={{ width: "100%" }}>
      <p
        style={{
          fontWeight: 500,
          fontSize: 40,
          width: "100%",
          textAlign: "center",
          color: "#5C626C"
        }}
      >
        How it Works{" "}
      </p>
    </div> */}

      <div
        className="col"
        style={{
          paddingBottom: "10px"
        }}
      >
        <Card className="how-it-works-card" style={{}}>
          <div className="card-content-wrapper">
            <img
              src={HelpingUp}
              alt="Kinder helping others"
              style={{ width: "120px" }}
            />
            <p style={{ fontWeight: 500, fontSize: 26 }}>Help your teammates</p>
            <p style={{}}>
              {" "}
              Mentor a newer employee, or pick up lunch for your teammate while
              you're at the store.{" "}
            </p>
          </div>
        </Card>
      </div>
      <div
        className="col"
        style={{
          paddingBottom: "10px"
        }}
      >
        <Card className="how-it-works-card" style={{}}>
          <div className="card-content-wrapper">
            <img
              src={NeedHelp}
              alt="Kinder get help"
              style={{ width: "120px" }}
            />

            <p style={{ fontWeight: 500, fontSize: 26, width: "100%" }}>
              Get help when you need it
            </p>
            <p style={{}}>
              Maybe you need a petsitter when
              you're on vacation, or a ride to work.
            </p>
          </div>
        </Card>
      </div>
      <div
        className="col"
        style={{
          paddingBottom: "10px"
        }}
      >
        <Card className="how-it-works-card" style={{}}>
          <div className="card-content-wrapper">
            <img
              src={MovieTix}
              alt="Kinder incentives movie tickets"
              style={{ width: "120px" }}
            />

            <p style={{ fontWeight: 500, fontSize: 26 }}>Tangible incentives</p>
            <p>
              Take advantage of offers from our partners, or create
              company-specific rewards.
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default HowItWorks;
